<a class="notification-link" (click)="downloadFile()">{{
    'Dashboard::ClickHereToDownloadEvaluatorPerformanceReport' | abpLocalization
  }}</a>